import { render, staticRenderFns } from "./AcessoNegado.vue?vue&type=template&id=2a37a702&scoped=true&lang=pug"
import script from "./AcessoNegado.vue?vue&type=script&lang=js"
export * from "./AcessoNegado.vue?vue&type=script&lang=js"
import style0 from "./AcessoNegado.vue?vue&type=style&index=0&id=2a37a702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a37a702",
  null
  
)

export default component.exports